/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var FlagAIcon20Solid = forwardRef('FlagAIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M4 2a2 2 0 0 0-2 2v14.75a1.25 1.25 0 1 0 2.5 0V14H17c1.03 0 1.618-1.176 1-2l-2.775-3.7a.5.5 0 0 1 0-.6L18 4c.618-.824.03-2-1-2H4Z" })));
});
